let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gkfia")).then(() => parcelRequire('l8jlf'));